'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { buildShareUrl } from '@/components/portfolio/share/share-pnl-button.utils';
import { AnimatedButton } from '@/components/ui/animated-button';
import { LinkForwardIconSolid } from '@/components/ui/icon/glyphs';
import { useFormattedCurrency } from '@/lib/currency';
import { useUserNetwork } from '@/lib/network/client';
import { ShareModal } from '@/lib/share';
export function PortfolioPositionShareButton(t0) {
  const $ = _c(36);
  const {
    destinationPath,
    marketPubkey,
    marketTitle,
    walletPubkey,
    outcomeIndex,
    outcomeTitle,
    closed,
    heroPnlD6
  } = t0;
  const t = useTranslations("profile.stats.positions");
  const tShare = useTranslations("portfolio.share");
  const {
    formatD6Signed
  } = useFormattedCurrency();
  const {
    network
  } = useUserNetwork();
  const t1 = network === "mainnet" ? "mainnet" : "devnet";
  let t2;
  if ($[0] !== closed || $[1] !== destinationPath || $[2] !== heroPnlD6 || $[3] !== marketPubkey || $[4] !== outcomeIndex || $[5] !== t1 || $[6] !== walletPubkey) {
    t2 = buildShareUrl(marketPubkey, walletPubkey, outcomeIndex, t1, heroPnlD6, closed, destinationPath);
    $[0] = closed;
    $[1] = destinationPath;
    $[2] = heroPnlD6;
    $[3] = marketPubkey;
    $[4] = outcomeIndex;
    $[5] = t1;
    $[6] = walletPubkey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const shareUrl = t2;
  let t3;
  if ($[8] !== formatD6Signed || $[9] !== heroPnlD6 || $[10] !== marketTitle || $[11] !== outcomeTitle || $[12] !== tShare) {
    const pnlText = heroPnlD6 !== undefined && heroPnlD6.length > 0 && heroPnlD6 !== "0" ? formatD6Signed(heroPnlD6) : null;
    t3 = pnlText === null ? tShare("tweetText", {
      marketTitle,
      outcomeLabel: outcomeTitle
    }) : tShare("tweetTextWithPnl", {
      pnl: pnlText,
      marketTitle,
      outcomeLabel: outcomeTitle
    });
    $[8] = formatD6Signed;
    $[9] = heroPnlD6;
    $[10] = marketTitle;
    $[11] = outcomeTitle;
    $[12] = tShare;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const tweetText = t3;
  let t4;
  if ($[14] !== heroPnlD6) {
    t4 = heroPnlD6 !== undefined ? {
      cacheVersion: heroPnlD6
    } : {};
    $[14] = heroPnlD6;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== closed) {
    t5 = closed ? {
      closed: true
    } : {};
    $[16] = closed;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== marketPubkey || $[19] !== outcomeIndex || $[20] !== t4 || $[21] !== t5 || $[22] !== walletPubkey) {
    t6 = {
      kind: "pnl_position",
      marketPubkey,
      walletPubkey,
      outcomeIndex,
      ...t4,
      ...t5
    };
    $[18] = marketPubkey;
    $[19] = outcomeIndex;
    $[20] = t4;
    $[21] = t5;
    $[22] = walletPubkey;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== tShare) {
    t7 = tShare("modalTitle");
    $[24] = tShare;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t) {
    t8 = t("shareAriaLabel");
    $[26] = t;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <AnimatedButton variant="secondary" size="sm" prefix={LinkForwardIconSolid} data-testid="position-row-share-link" aria-label={t8} />;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== shareUrl || $[31] !== t6 || $[32] !== t7 || $[33] !== t9 || $[34] !== tweetText) {
    t10 = <ShareModal surface={t6} url={shareUrl} text={tweetText} title={t7} trigger={t9} />;
    $[30] = shareUrl;
    $[31] = t6;
    $[32] = t7;
    $[33] = t9;
    $[34] = tweetText;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}